import { AngefertigtIcon, AbgeschicktIcon, InterviewIcon, ZusageIcon, AbsageIcon } from './AnalyticsIcons';

export const STATUS_CONFIG = {
  '':                      { label: '— Kein Status —', color: '#888880', bg: 'rgba(136,136,128,0.12)', border: 'rgba(136,136,128,0.3)',  Icon: null            },
  unterlagen_angefertigt:  { label: 'Angefertigt',     color: '#7C6F64', bg: 'rgba(124,111,100,0.12)', border: 'rgba(124,111,100,0.3)', Icon: AngefertigtIcon },
  abgeschickt:             { label: 'Abgeschickt',     color: '#0284c7', bg: 'rgba(2,132,199,0.12)',   border: 'rgba(2,132,199,0.35)',  Icon: AbgeschicktIcon },
  kennenlerngespraech:     { label: 'Interview',       color: '#d97706', bg: 'rgba(217,119,6,0.12)',   border: 'rgba(217,119,6,0.35)',  Icon: InterviewIcon   },
  zusage:                  { label: 'Zusage!',         color: '#059669', bg: 'rgba(5,150,105,0.12)',   border: 'rgba(5,150,105,0.35)',  Icon: ZusageIcon      },
  absage:                  { label: 'Absage',          color: '#dc2626', bg: 'rgba(220,38,38,0.12)',   border: 'rgba(220,38,38,0.35)',  Icon: AbsageIcon      },
};

export const EXTERN_STATUS_OPTIONEN = [
  { value: 'abgeschickt',        label: 'Abgeschickt' },
  { value: 'kennenlerngespraech', label: 'Kennenlerngespräch' },
  { value: 'zusage',             label: 'Zusage' },
  { value: 'absage',             label: 'Absage' },
];

export const EXTERN_INIT = {
  name: '',
  plattform: '',
  empfaenger_ansprechperson: '',
  bewerbungs_status: 'abgeschickt',
  abschick_datum: '',
  interview_datum: '',
  interview_uhrzeit: '',
  gehaltsvorstellung: '',
};

export const STATUS_OPTIONEN = [
  { value: 'unterlagen_angefertigt', label: 'Angefertigt'     },
  { value: 'abgeschickt',            label: 'Abgeschickt'     },
  { value: 'kennenlerngespraech',    label: 'Interview'       },
  { value: 'zusage',                 label: 'Zusage!'         },
  { value: 'absage',                 label: 'Absage'          },
];

export const KPI_DEFS = [
  { key: 'submitted', label: 'ABGESCHICKT', bg: '#FFBC00', text: '#3A2700', sub: 'rgba(58,39,0,0.58)' },
  { key: 'interview', label: 'INTERVIEWS',  bg: '#FEFCF6', text: '#1C1A16', sub: '#7D776F'            },
  { key: 'zusage',    label: 'ZUSAGEN',     bg: '#E8F5EF', text: '#004D30', sub: 'rgba(0,77,48,0.60)' },
  { key: 'absage',    label: 'ABSAGEN',     bg: '#FDEEED', text: '#7A1F10', sub: 'rgba(122,31,16,0.60)' },
];

export const STATUS_ITEMS = [
  { value: 'kein_status',            label: '— Kein Status —', dot: '#9CA3AF' },
  { value: 'unterlagen_angefertigt', label: 'Angefertigt',     dot: '#9CA3AF' },
  { value: 'abgeschickt',            label: 'Abgeschickt',     dot: '#3B82F6' },
  { value: 'kennenlerngespraech',    label: 'Interview',        dot: '#F59E0B' },
  { value: 'zusage',                 label: 'Zusage!',          dot: '#22C55E' },
  { value: 'absage',                 label: 'Absage',           dot: '#EF4444' },
];

export const ALL_STATUS_VALUES = STATUS_ITEMS.map(s => s.value);

export const MONATE_DE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
export const DOW_DE    = ['Mo','Di','Mi','Do','Fr','Sa','So'];

export const NOTE_TAG_COLORS = {
  ANRUF:     { bg: 'rgba(255,102,0,0.14)', color: '#CC4400' },
  EMAIL:     { bg: 'rgba(2,132,199,0.12)', color: '#0369a1' },
  TERMIN:    { bg: 'rgba(255,188,0,0.18)', color: '#7A5000' },
  MEETING:   { bg: 'rgba(255,188,0,0.18)', color: '#7A5000' },
  INTERVIEW: { bg: 'rgba(0,77,64,0.12)',   color: '#004D40' },
  ABSAGE:    { bg: 'rgba(220,38,38,0.12)', color: '#dc2626' },
  ZUSAGE:    { bg: 'rgba(5,150,105,0.12)', color: '#059669' },
};
